<div id="paypal-gold-button-indra" class="button-width" [ngClass]="{'disable-class': !formIsValid}">
</div>

<!--
<div id="paypal-blue-button-indra" class="button-width" [ngStyle]="{'display': savePaypalChecked ? 'inline-block' : 'none'}"
[ngClass]="{'disable-class': !formIsValid}">
</div>
-->
